/**
 * Origin of the game host — e.g. "https://play.corsalia.net" in prod, "" in dev
 * (so links stay same-host and client-side). Read at call-time, not as a module
 * const, so it can be stubbed per-test with vi.stubEnv('VITE_PLAY_ORIGIN', …).
 */
export function playOrigin(): string {
  return import.meta.env.VITE_PLAY_ORIGIN ?? ''
}

/**
 * Canonical origin of the public vitrine. Every canonical URL points here so
 * search ranking consolidates on the apex host regardless of which host served
 * the page (apex or play).
 */
export const CANONICAL_ORIGIN = 'https://corsalia.net'

/**
 * Durée nominale d'une saison, en semaines. Miroir de
 * `App\Domain\Season\SeasonCalendar::LENGTH` (`'+12 weeks'`).
 *
 * Elle ne décrit QUE la durée d'une saison neuve : le compteur « semaine X sur
 * Y » affiché en jeu vient du serveur, dérivé de la ligne de la saison vivante,
 * et n'a rien à voir avec ce chiffre. La Saison du Calibrage, ouverte sur seize
 * semaines, est là pour le rappeler.
 *
 * Les deux conteneurs de dev sont cloisonnés : aucun test ne lit les deux arbres
 * à la fois. Le contrat tient par deux épingles qui se renvoient l'une à
 * l'autre, `front/src/pages/SeasonDuration.test.tsx` et
 * `api/tests/Domain/Season/SeasonCalendarTest.php`.
 */
export const SEASON_LENGTH_WEEKS = 12
